<template>
  <div>
    <SearchComponent
      :isAdd="true"
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      @on-add="add"
      :authIdentity="authIdentity"
      @back="back"
      :backFalg="true"
      :isDefault="true"
      :defaultSearch="{villname:village.villname }"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :total="total"
      :tableData="tableData"
      @pageChange="handleSearch"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':edit']"
          class="button"
          type="text"
          size="small"
          @click="handleUpdata(scope.data, scope.$index)"
        >修改</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="handleSee(scope.data, scope.$index)"
        >详情</el-button>
        <el-button
          v-hasPermi="[authIdentity + ':del']"
          class="delbutton"
          type="text"
          size="small"
          @click="handleDel(scope.data, scope.$index)"
        >删除</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView" :type="type"></component>
      <span slot="footer" v-if="type != 'preview'">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom">确 定</el-button>
      </span>
    </Mdialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/library/fence/components/form'

import { getRegiontList, delregion } from '@/api/library/vallage'
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
  },
  data() {
    return {
      authIdentity: 'library:village',
      dialogVisible: false,
      title: '',
      currentView: '',
      defaultSearch: {
        villname: '',
        name: '',
      },
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      type: '',
      colLists: [
        {
          prop: 'name',
          label: '围名称',
          isTrue: true,
        },
        {
          prop: 'remark',

          label: '备注',
          isTrue: true,
        },

        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        level: 7,

        parentId: '',
      },
      tableData: [],
      selectOrInputList: [
        {
          model: 'villname',
          placeholder: '请输入村名称',
          class: 'home',
          type: 'input',
          disabled: true,
        },
        {
          model: 'name',
          placeholder: '请输入围名称',
          class: 'home',
          type: 'input',
        },
      ],
      village: {
        parentId: '',
        name: '',
        parentFullName: '',
      },
    }
  },
  created() {
    console.log(this.$route.query, 'aaaaaaaaaaaaaaaaaaaaaaaaaa')
    // this.queryParams.villname = this.$route.query.name

    // this.defaultSearch.villname = this.$route.query.name
    // this.defaultSearch.name = null
    this.village.parentFullName = this.$route.query.parentFullName
    this.village.parentId = this.$route.query.parentId
    this.village.villname = this.$route.query.name
    this.village.parentFullCodeList = this.$route.query.parentFullCodeList
    this.village.parentFullCodeList.push(this.$route.query.code)
    // .push(this.$route.query.code)
    this.queryParams.parentId = this.$route.query.parentId
    this.getRegiontList()
  },
  methods: {
    handleDel(row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonClass: 'confirm_button',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          delregion(row.id).then((response) => {
            if (response.code == 200 && response.flag) {
              this.$message.success(`操作成功！`)
              this.getRegiontList()
            } else {
              this.$message.warning(response.message)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    handleSee(row) {
      this.dialogVisible = true
      this.title = '查看围'
      this.currentView = 'myform'
      this.type = 'preview'
      this.$nextTick(() => {
        this.$refs.myform.getDetail(row, this.type)
      })
    },
    back() {
      this.$router.push('/village')
    },
    submitFrom() {
      console.log('进来')
      this.$refs.myform.submit(this.type, (data) => {
        console.log(data)

        if (data) {
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getRegiontList()
        }
      })
    },
    cancel() {
      this.$refs.myform.reset()
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '新增围'

        this.type = 'add'

        this.$refs.myform.add(this.village, this.type)
      })
    },
    handleUpdata(row) {
      let that = this
      this.dialogVisible = true
      this.currentView = 'myform'
      this.$nextTick(() => {
        this.title = '修改围信息'
        console.log(that.$refs.myform, ' this.$refs.my111111111111form.getDetail------------')
        this.$refs.myform.getDetail(row)

        this.type = 'edit'
      })
    },
    handleFence(row) {
      console.log('围明细')

      this.$router.push({ path: '/fence' })
    },
    getRegiontList() {
      getRegiontList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items
            this.total = res.data.totalCount
            console.log(this.tableData, 'this.tableDatathis.tableData--------------')
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    handleSearch(data) {
      console.log(data, '----------------------')
      if (data) {
        for (let key in data) {
          this.queryParams[key] = data[key]
        }
      }

      this.getRegiontList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        level: 7,
        villname: this.village.villname,
        parentId: this.village.parentId,
      }
      this.village.villname = this.$route.query.name
      this.getRegiontList()
    },
  },
}
</script>
<style scoped lang='less'>
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
</style>